"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import ClubDetailCard from "@/app/(main)/(club)/mes-clubs/[id]/club-detail-card";
import ToggleEditIcon from "@/app/(main)/(club)/mes-clubs/[id]/components/toggle-edit-icon";
import { ClubSettingsModal } from "@/app/(main)/(club)/mes-clubs/components/[modify-club-settings]/club-settings-modal";
import ClientStartEndDate from "@/app/(main)/_club_detail_components/client-start-end-date";
import ComponentLoading from "@/components/global/component-loading";
import useMobile from "@/hooks/use-mobile";
import { days } from "@/lib/general-constants";
import { useModalStore } from "@/stores/modal-store";
import { RegularityCardProps } from "@/TS/Interfaces/global_interfaces";
function RegularityCard(t0) {
  const $ = _c(26);
  const {
    format,
    club,
    showIcon: t1
  } = t0;
  const showIcon = t1 === undefined ? true : t1;
  const [isEditing, setIsEditing] = useState(false);
  const router = useRouter();
  const isMobile = useMobile();
  let t2;
  if ($[0] !== isEditing || $[1] !== router) {
    t2 = () => {
      setIsEditing(!isEditing);
      useModalStore.getState().open({
        component: <ClubSettingsModal />,
        modalOptions: {
          closeOnOverlayClick: false,
          stopPropagation: false,
          loader: {
            component: <ComponentLoading />
          },
          size: {
            width: "w-[40rem]",
            minHeight: "h-[40rem]"
          },
          onClose: () => {
            router.refresh();
          }
        }
      });
    };
    $[0] = isEditing;
    $[1] = router;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleToggle = t2;
  const t3 = `${format.borderColor}  border-2 break-all text-xs justify-center md:text-lg relative break-words`;
  let t4;
  if ($[3] !== handleToggle || $[4] !== showIcon) {
    t4 = showIcon && <ToggleEditIcon onToggle={handleToggle} className="absolute top-0 right-0 w-6 h-6 md:w-8 md:h-8 md:top-2 md:right-2" />;
    $[3] = handleToggle;
    $[4] = showIcon;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== format.description) {
    t5 = <span className="md:mb-2 md:mt-2 truncate mt-3 font-bold text-sm xl:text-lg break-words">{format.description}</span>;
    $[6] = format.description;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `${format.color} text-sm gap-2 flex xl:text-lg font-bold`;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      flexWrap: "wrap",
      justifyContent: "center"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = days[club.dayWeek as keyof typeof days];
  let t9;
  if ($[9] !== club.closingTime || $[10] !== club.openingTime) {
    t9 = <p className="text-nowrap flex items-center justify-center"><ClientStartEndDate openingTime={club.openingTime} closingTime={club.closingTime} /></p>;
    $[9] = club.closingTime;
    $[10] = club.openingTime;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t8.long || $[14] !== t9) {
    t10 = <span className={t6} style={t7}>{t8.long}{" "}{t9}</span>;
    $[12] = t6;
    $[13] = t8.long;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== format.color || $[17] !== format.description2 || $[18] !== isMobile) {
    t11 = !isMobile && <span className={`${format.color} text-2xs lg:text-lg font-bold`}>{format.description2}</span>;
    $[16] = format.color;
    $[17] = format.description2;
    $[18] = isMobile;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t12 = <ClubDetailCard className={t3}>{t4}{t5}{t10}{t11}</ClubDetailCard>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}
export default RegularityCard;